import { z } from 'zod';

/**
 * Dashboard stats response schema (D-35).
 * Aggregated operational metrics for the panel dashboard,
 * scoped to the authenticated user's organization.
 */
export const DashboardStatsResponse = z.object({
  accounts: z.object({
    total: z.number(),
    active: z.number(),
    degraded: z.number(),
    failed: z.number(),
  }),
  integrations: z.object({
    healthy: z.number(),
    degraded: z.number(),
    failed: z.number(),
    notInstalled: z.number(),
  }),
  commands24h: z.object({
    total: z.number(),
    pending: z.number(),
    executed: z.number(),
    failed: z.number(),
  }),
  jobs24h: z.object({
    failed: z.number(),
    total: z.number(),
  }),
  sales24h: z.object({
    received: z.number(),
    attributed: z.number(),
    unattributed: z.number(),
  }),
  snapshotAge: z.object({
    oldestMinutes: z.number().nullable(),
    avgMinutes: z.number().nullable(),
  }),
});

export type DashboardStats = z.infer<typeof DashboardStatsResponse>;
